import axios from 'axios';

const MESSAGES: Record<string, string> = {
  forbidden: 'You do not have permission to do that.',
  not_your_zone: 'You can only report issues in your own zones.',
  invalid_transition: 'This issue has already moved on. Refresh and try again.',
  invalid_assignee: 'Choose an active staff member to assign.',
  invalid_category: 'Choose an active category.',
  too_many_photos: 'You can attach up to 5 photos.',
  invalid_image: 'Photos must be JPEG, PNG or WebP images under 10 MB.',
  duplicate: 'That name is already in use.',
  no_access: 'You do not have access to this module.',
  telegram_disabled: 'Telegram notifications are not available right now.',
  validation: 'Please check the form and try again.',
  invalid_body: 'Please check the form and try again.',
  invalid_query: 'Please check the form and try again.',
  invalid_councillor: 'Only active councillors can be linked to a zone.',
  not_found: 'That item could not be found.',
};

const FALLBACK = 'Something went wrong. Please try again.';

/** Maps an API `{ error: '<code>' }` failure (or any thrown value) to an English message. */
export function zoneErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const code = (err.response?.data as { error?: unknown } | undefined)?.error;
    if (typeof code === 'string' && MESSAGES[code]) return MESSAGES[code];
    if (!err.response) return 'Network error. Check your connection and try again.';
  }
  return FALLBACK;
}
